import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export interface CancelEnrollmentRequestInput {
  reason: string
}

export const cancelEnrollmentRequest = (
  enrollmentId: number,
  input: CancelEnrollmentRequestInput
) => {
  return restApiClient
    .url(constructApiUrl(API.enrollments.cancelEnrollmentRequest.url, { id: enrollmentId }))
    .post(input)
}
